import React from "react"
import { Tabs, Tab } from "material-ui"
import JobDashboardWorkEmployeeDetail from "./job_dashboard_detail/JobDashboardWorkEmployeeDetail"
import JobDashboardOvertimeDetail from "./job_dashboard_detail/JobDashboardOvertimeDetail"
import { EDashboardDetailType, EOTEmployeeType, IDate } from "../../../../models"
import strings from "../../../../localization/strings"
import { amber500 } from "material-ui/styles/colors"
interface IProps {
    jobId: string
    utcTime: IDate
    selectedDay: IDate
    isToday: boolean
    activatedTab: EDashboardDetailType
    handleChangeActivatedTab(activatedTab: EDashboardDetailType): void
}

const JobDashboardDetail: React.SFC<IProps> = (props: IProps) => {
    return (
        <Tabs
            style={{ marginTop: 5 }}
            value={props.activatedTab}
            onChange={activatedTab => props.handleChangeActivatedTab(activatedTab)}
        >
            <Tab
                value={EDashboardDetailType.WorkingEmployee}
                label={
                    <span>
                        {props.isToday ? strings.Working_Employees : strings.Worked_Employees}
                        {props.activatedTab === EDashboardDetailType.WorkingEmployee &&
                            <i
                                className="fa fa-info-circle"
                                style={{ color: amber500, fontSize: 16, marginLeft: 10 }}
                                title={props.isToday ? strings.JobDashboardWorkingEmployeeTooltip : strings.JobDashboardWorkedEmployeeTooltip}
                            />
                        }
                    </span>
                }
            >
                {props.activatedTab === EDashboardDetailType.WorkingEmployee &&
                    <JobDashboardWorkEmployeeDetail
                        jobId={props.jobId}
                        utcTime={props.utcTime}
                        isToday={props.isToday}
                        selectedDay={props.selectedDay}
                    />
                }
            </Tab>
            <Tab
                value={EDashboardDetailType.ApproachingOT}
                label={
                    <span>
                        {strings.Approaching_Overtime}
                        {props.activatedTab === EDashboardDetailType.ApproachingOT &&
                            <i
                                className="fa fa-info-circle"
                                style={{ color: amber500, fontSize: 16, marginLeft: 10 }}
                                title={props.isToday ? strings.JobDashboardTodayApproachingOvertimeTooltip : strings.JobDashboardOldDayApproachingOvertimeTooltip}
                            />
                        }
                    </span>
                }
            >
                {props.activatedTab === EDashboardDetailType.ApproachingOT &&
                    <JobDashboardOvertimeDetail
                        type={EOTEmployeeType.ApproachingOT}
                        jobId={props.jobId}
                        utcTime={props.utcTime}
                        selectedDay={props.selectedDay}
                    />
                }
            </Tab>
            <Tab
                value={EDashboardDetailType.OT}
                label={
                    <span>
                        {strings.Overtime}
                        {props.activatedTab === EDashboardDetailType.OT &&
                            <i
                                className="fa fa-info-circle"
                                style={{ color: amber500, fontSize: 16, marginLeft: 10 }}
                                title={props.isToday ? strings.JobDashboardTodayOvertimeTooltip : strings.JobDashboardOldDayOvertimeTooltip}
                            />
                        }
                    </span>
                }
            >
                {props.activatedTab === EDashboardDetailType.OT &&
                    <JobDashboardOvertimeDetail
                        type={EOTEmployeeType.OT}
                        jobId={props.jobId}
                        utcTime={props.utcTime}
                        selectedDay={props.selectedDay}
                    />
                }
            </Tab>
        </Tabs>
    )
}

export default JobDashboardDetail